
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/migrator",
      function () {
        return require("private-next-pages/migrator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/migrator"])
      });
    }
  